module.exports = __webpack_public_path__ + "static/hero-img-dfd3b36c00ae88580b102dbdc9f0d1e0.png";